// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
/// <summary>
/// Обертка вектора результата
/// </summary>
export let ResVector = function (rowNumber, timeShift, priceMult, vector)
{
    this.FRowNumber = rowNumber;
    this.FTimeShift = timeShift;
    this.FPriceMult = priceMult;
    this.Vector = vector;
}
Object.defineProperty(ResVector.prototype, "TimeShift",
    {
        get: function () { return this.FTimeShift[this.FRowNumber]; },
    });

//#region IDoubleVector Members

ResVector.prototype.get = function (index)
{
    let priceMult = this.FPriceMult[this.FRowNumber];
    return index >= 0 && index < this.Vector.Length ? this.Vector.get(index) * priceMult : 0.0;
}
ResVector.prototype.set = function (index, value)
{
    this.Vector.set(index, value);
}

Object.defineProperty(ResVector.prototype, "Length",
    {
        get: function () { return this.Vector.Length; },
    });


//#endregion

ResVector.prototype.Dispose = function ()
{
    if (this.Vector != null)
    {
        this.Vector.Dispose();
        this.Vector = null;
    }
}

